// extracted by mini-css-extract-plugin
export default {"container":"PeopleNavigation_container__nl4fO","buttons":"PeopleNavigation_buttons__765cK"};